export const nextApiRoutes = {
  recaptchaV3: '/api/recaptcha-v3',
};
